import RatingForm from './RatingFormContainer';

export default RatingForm;
